import { createSlice } from '@reduxjs/toolkit';
export const siteInitialState = {
    siteMetadata: {}
};
const siteSlice = createSlice({
    name: 'site',
    initialState: siteInitialState,
    reducers: {
        updateSiteMetadata: (state, action) => {
            state.siteMetadata = {
                ...state.siteMetadata,
                ...action.payload
            };
        },
        discardAllChanges: state => {
            state.siteMetadata = {};
        }
    }
});
export const actions = siteSlice.actions;
export default siteSlice.reducer;
